import axios from "axios";
import CryptoJS from 'crypto-js';

const secret = 'my_super_secure_shared_secret_key_123';
const clientId = '1234567890abcdef';

function stableStringify(obj) {
  return JSON.stringify(obj, Object.keys(obj).sort());
}

let customAxios = axios.create({
  baseURL: "https://jeema.co/api/v2/"
  // baseURL: "http://localhost:5000/api/v2/"
});

customAxios.interceptors.request.use((config) => {
    const token = JSON.parse(localStorage.getItem("token"));
    if (token?.token) {
      config.headers.Authorization = `Bearer ${token.token}`;
    }
  
    const timestamp = Date.now().toString();
    const nonce = Math.random().toString(36).substr(2, 9);
  
    // For GET requests, use empty body
    let body = config.method === 'get' ? {} : (config.data || {});
  
    // Sort keys for stable hashing
    const stableBody = JSON.stringify(body, Object.keys(body).sort());
  
    const bodyHash = CryptoJS.SHA256(stableBody).toString(CryptoJS.enc.Hex);
    const signature = CryptoJS.HmacSHA256(clientId + timestamp + nonce + bodyHash, secret).toString(CryptoJS.enc.Hex);
  
    config.headers['x-body-hash'] = bodyHash;
    config.headers['x-app-signature'] = signature;
    config.headers['x-client-id'] = clientId;
    config.headers['x-timestamp'] = timestamp;
    config.headers['x-nonce'] = nonce;
  
    return config;
  }, (error) => Promise.reject(error));

// 401 Handling (move to response interceptor)
customAxios.interceptors.response.use((response) => response, (error) => {
  if (error.response?.status === 401) {
    localStorage.clear();
    window.location.href = "/login";  // navigate isn't available outside components
  }
  return Promise.reject(error);
});

export async function postApi(path, data) {
  return await customAxios.post(`/${path}`, data);
}

export async function putApi(path, data) {
  return await customAxios.put(`/${path}`, data);
}

export async function getApi(path, params = {}) {
    return await customAxios.get(`/${path}`, { params });
  }

  export async function deleteApi(path, data) {
    return await customAxios.delete(`/${path}`, data);
  }
